import { render, staticRenderFns } from "./edit-tabs.vue?vue&type=template&id=76cf722a&"
import script from "./edit-tabs.vue?vue&type=script&lang=ts&"
export * from "./edit-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports